import SectionHeading from "./SectionHeading";
import PosterCard from "./PosterCard";
import { catalogAnime, featuredAnime } from "@/mocks/anime";

const jpPool = [...featuredAnime, ...catalogAnime].filter((item) => item.region === "日漫");
const cnPool = [...featuredAnime, ...catalogAnime].filter((item) => item.region === "国漫");

const jpPoints = [
  { icon: "ri-book-2-line", title: "季播节奏", desc: "按季度连载，多数作品以 11–26 话为一季，追更节奏固定。" },
  { icon: "ri-palette-line", title: "题材细分", desc: "从运动、音乐到异世界，类型边界清晰，容易按喜好筛选。" },
  { icon: "ri-music-2-line", title: "配乐标识", desc: "oped 与剧伴常常成为作品记忆点，片头片尾值得留意。" },
];

const cnPoints = [
  { icon: "ri-brush-line", title: "东方美学", desc: "水墨与国风美术常见，仙侠、历史、武侠题材占比较高。" },
  { icon: "ri-computer-line", title: "3D 与二维并行", desc: "3D 长篇与精致二维并存，动作场面调度越来越成熟。" },
  { icon: "ri-quill-pen-line", title: "改编为主", desc: "多改编自网络小说与漫画，长线世界观较为常见。" },
];

export default function RegionSplit() {
  return (
    <section id="region" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <SectionHeading
        eyebrow="两条内容线"
        icon="ri-earth-line"
        title="日漫与国漫 · 两种不同的观看路径"
        description="日漫与国漫在题材偏好、更新方式与美术风格上各有侧重。这里把两条线分开呈现，方便你按自己的口味选择入口。"
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
        {/* 日漫 */}
        <div className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
          <div className="flex items-center justify-between px-5 py-4 bg-primary-100">
            <span className="flex items-center gap-2 font-heading text-lg font-bold text-primary-900">
              <i className="ri-macbook-line" aria-hidden="true"></i>
              日漫专区
            </span>
            <span className="text-xs text-primary-800">{jpPool.length} 部条目</span>
          </div>

          <div className="p-5 space-y-3">
            {jpPoints.map((point) => (
              <div key={point.title} className="flex gap-3">
                <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${point.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-950">{point.title}</span>
                  <span className="block text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {point.desc}
                  </span>
                </span>
              </div>
            ))}
          </div>

          <div className="px-5 pb-5">
            <div className="grid grid-cols-3 gap-3">
              {jpPool.slice(0, 3).map((item) => (
                <PosterCard
                  key={item.id}
                  title={item.title}
                  cover={item.cover}
                  genre={item.genre}
                  compact
                />
              ))}
            </div>
          </div>
        </div>

        {/* 国漫 */}
        <div className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
          <div className="flex items-center justify-between px-5 py-4 bg-secondary-100">
            <span className="flex items-center gap-2 font-heading text-lg font-bold text-secondary-900">
              <i className="ri-ink-bottle-line" aria-hidden="true"></i>
              国漫专区
            </span>
            <span className="text-xs text-secondary-800">{cnPool.length} 部条目</span>
          </div>

          <div className="p-5 space-y-3">
            {cnPoints.map((point) => (
              <div key={point.title} className="flex gap-3">
                <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${point.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-950">{point.title}</span>
                  <span className="block text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {point.desc}
                  </span>
                </span>
              </div>
            ))}
          </div>

          <div className="px-5 pb-5">
            <div className="grid grid-cols-3 gap-3">
              {cnPool.slice(0, 3).map((item) => (
                <PosterCard
                  key={item.id}
                  title={item.title}
                  cover={item.cover}
                  genre={item.genre}
                  compact
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}